module.exports = __webpack_public_path__ + "static/img/subcontract3.b7c6528b.png";